import { getRoutePathSegments } from '@common/utils/browser/get-route-path-segments';
import { IModuleModel } from '@core/types/models';

export const getCurrentModule = (modules: IModuleModel[], pathname?: string) => {
  const allModulesPaths = modules.map((module: IModuleModel) => module.path);
  const routePathSegments = getRoutePathSegments(pathname);
  const path = allModulesPaths.filter((p) => p && routePathSegments.includes(p)).join('');
  return modules.find((module) => module.path === path)!;
};
